import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-card-clickable',
  templateUrl: './card-clickable.component.html',
  imports: [TranslateDirective, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardClickableComponent {
  cardTitle = input.required<string>();
  cardIcon = input.required<string>();
  ariaLabel = input<string>('');
  isLoading = input<boolean>(false);
  testId = input<string>('');
  cardClicked = output();

  onCardClick() {
    if (this.isLoading()) {
      return;
    }

    this.cardClicked.emit();
  }
}
